import React from "react";
import { formatPhoneUS } from "utils/helperFunctions/phoneFormat";
import "./ClientProvidedInfo.css";

/**
 * True when the client typed any agent details on the public booking form.
 * These fields are only set by SchedulingAPI bookings; manual bookings leave
 * them null.
 */
export const hasClientProvidedAgent = (job) =>
  Boolean(
    job?.client_provided_agent_name ||
      job?.client_provided_agent_phone ||
      job?.client_provided_agent_email
  );

export const ClientProvidedNotes = ({ note }) => (
  <div className="client-provided-card client-provided-notes">
    <div className="client-provided-card-title">Client-Provided Notes</div>
    <div className="client-provided-card-content">{note}</div>
  </div>
);

export const ClientProvidedAgent = ({ job }) => {
  const {
    client_provided_agent_name: name,
    client_provided_agent_phone: phone,
    client_provided_agent_email: email,
  } = job;

  return (
    <div className="client-provided-card client-provided-agent">
      <div className="client-provided-card-title">Client-Provided Agent</div>
      {name && <div className="client-provided-agent-name">{name}</div>}
      {(phone || email) && (
        <div className="client-provided-agent-details">
          {phone && <span>{formatPhoneUS(phone)}</span>}
          {email && <span>{email}</span>}
        </div>
      )}
    </div>
  );
};
